import axios, { AxiosResponse } from 'axios'

import { SearchGuestRead, SearchResidencyRead, SearchShowRead } from '@generated/types'

export type SearchResponse = {
  guests: SearchGuestRead[]
  shows: SearchShowRead[]
  residencies: SearchResidencyRead[]
}

const BASE_URL = '/api/search'

export default {
  async search(query: string): Promise<AxiosResponse<SearchResponse>> {
    return axios.get(`${BASE_URL}/?q=${query}`)
  },
}
